import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.scss';
import { Provider } from 'react-redux';
import store from './store';
import CreateTemplate from './services/email/createTemplate';


if( process.env.REACT_APP_CREATE_AWS_TEMPLATE === 'true' ) {
  // Create AWS template
  CreateTemplate.run()
    .then( () => console.log('Template created') )
    .catch( (err) => console.log(err) );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
